import * as R from "ramda";
import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  EmailField,
  BooleanField,
  Filter,
  Edit,
  Create,
  SimpleForm,
  BooleanInput,
  DisabledInput,
  TextInput,
  SelectInput,
  SearchInput,
  required,
  maxLength,
  minLength,
  TabbedForm,
  FormTab,
  ReferenceManyField,
  ShowButton,
  FunctionField,
  ArrayField,
  SingleFieldList,
  ChipField,
  NumberField,
  Pagination,
} from "react-admin";
import {
  ClinicalFullNameField,
  DoctorReferenceField,
  PatientReferenceField,
} from "../../misc/customFields";
import { OkCancelToolbar } from "../../misc/customComponents";
import PatientsAside from "./PatientsAside";

import withStyles from "@material-ui/core/styles/withStyles";

const DoctrorFilter = (props) => (
  <Filter {...props}>
    <SearchInput source="q" alwaysOn />
  </Filter>
);

export const DoctorList = (props) => {
  return (
    <div>
      <List {...props} filters={<DoctrorFilter />} title="Clinicians">
        <Datagrid>
          <TextField source="id" />
          <DoctorReferenceField
            label="Clinician"
            source="id"
            sortBy="first_name"
          />
          <TextField source="pin_code" sortable={false} />
          <TextField
            source="specialization"
            sortBy="doctorprofile__specialization"
          />
          <EmailField source="email" />
          <BooleanField
            source="email_verified"
            sortBy="doctorprofile__email_is_verified"
          />
          <DateField source="last_login" />
          <TextField
            source="phone_number"
            sortBy="doctorprofile__phone_number"
          />
          <DateField source="date_joined" />
        </Datagrid>
      </List>
    </div>
  );
};

const editStyles = {
  root: { alignItems: "flex-start" },
};

const DoctorEdit_ = (props) => {
  return (
    <Edit {...props} aside={<PatientsAside />}>
      <SimpleForm toolbar={<OkCancelToolbar />}>
        <DisabledInput label="Id" source="id" />
        <TextInput source="first_name" validate={required()} />
        <TextInput source="last_name" validate={required()} />
        <TextInput source="email" type="email" validate={required()} />
        <TextInput
          source="phone_number"
          validate={[required(), minLength(6)]}
        />
        <SelectInput
          source="specialization"
          choices={[
            { id: "physiatrist", name: "physiatrist" },
            { id: "orthopedicSurgeon", name: "orthopedicSurgeon" },
            { id: "hospitalist", name: "hospitalist" },
            { id: "neurologist", name: "neurologist" },
            { id: "rheumatologist", name: "rheumatologist" },
            {
              id: "painManagementSpecialist",
              name: "painManagementSpecialist",
            },
            {
              id: "spinalCordInjurySpecialist",
              name: "spinalCordInjurySpecialist",
            },
            {
              id: "sportsMedicineSpecialist",
              name: "sportsMedicineSpecialist",
            },
            { id: "caregiver", name: "caregiver" },
            { id: "other", name: "other" },
          ]}
        />
        <TextInput source="pin_code" validate={[required(), maxLength(4)]} />
        <TextInput source="password" type="password" validate={minLength(8)} />
        <BooleanInput source="email_verified" />
      </SimpleForm>
    </Edit>
  );
};

export const DoctorEdit = withStyles(editStyles)(DoctorEdit_);

export const DoctorCreate = (props) => {
  return (
    <Create {...props} title="Create Clinician">
      <SimpleForm>
        <TextInput source="first_name" validate={required()} />
        <TextInput source="last_name" validate={required()} />
        <TextInput source="email" type="email" validate={required()} />
        <TextInput
          source="phone_number"
          validate={[required(), minLength(6)]}
        />
        <SelectInput
          source="specialization"
          choices={[
            { id: "physiatrist", name: "physiatrist" },
            { id: "orthopedicSurgeon", name: "orthopedicSurgeon" },
            { id: "hospitalist", name: "hospitalist" },
            { id: "neurologist", name: "neurologist" },
            { id: "rheumatologist", name: "rheumatologist" },
            {
              id: "painManagementSpecialist",
              name: "painManagementSpecialist",
            },
            {
              id: "spinalCordInjurySpecialist",
              name: "spinalCordInjurySpecialist",
            },
            {
              id: "sportsMedicineSpecialist",
              name: "sportsMedicineSpecialist",
            },
            { id: "caregiver", name: "caregiver" },
            { id: "other", name: "other" },
          ]}
        />
        <TextInput source="pin_code" validate={[required(), maxLength(4)]} />
        <TextInput
          source="password"
          type="password"
          validate={[required(), minLength(8)]}
        />
      </SimpleForm>
    </Create>
  );
};

const DoctorTitle = ({ record }) =>
  record ? <ClinicalFullNameField record={record} size={32} /> : null;

export const DoctorEdit2 = (props) => {
  return (
    <Edit title={<DoctorTitle />} {...props}>
      <TabbedForm>
        <FormTab label="Clinician">
          <DisabledInput label="Id" source="id" />
          <TextInput source="first_name" validate={required()} />
          <TextInput source="last_name" validate={required()} />
          <TextInput source="email" type="email" validate={required()} />
          <TextInput
            source="phone_number"
            validate={[required(), minLength(6)]}
          />
          <SelectInput
            source="specialization"
            choices={[
              { id: "physiatrist", name: "physiatrist" },
              { id: "orthopedicSurgeon", name: "orthopedicSurgeon" },
              { id: "hospitalist", name: "hospitalist" },
              { id: "neurologist", name: "neurologist" },
              { id: "rheumatologist", name: "rheumatologist" },
              {
                id: "painManagementSpecialist",
                name: "painManagementSpecialist",
              },
              {
                id: "spinalCordInjurySpecialist",
                name: "spinalCordInjurySpecialist",
              },
              {
                id: "sportsMedicineSpecialist",
                name: "sportsMedicineSpecialist",
              },
              { id: "caregiver", name: "caregiver" },
              { id: "other", name: "other" },
            ]}
          />
          <TextInput
            source="pin_code"
            type="number"
            validate={[required(), maxLength(4)]}
          />
          <TextInput
            source="password"
            type="password"
            validate={minLength(8)}
          />
          <BooleanInput source="email_verified" />
        </FormTab>
        <FormTab label="Patients">
          <ReferenceManyField
            addLabel={false}
            sort={{ field: "id", order: "DESC" }}
            reference="patients"
            target="doctor"
            pagination={<Pagination />}
          >
            <Datagrid>
              <TextField source="id" />
              <PatientReferenceField label="Patient" />
              <EmailField source="email" />
              <TextField source="gender" />
              <TextField source="phone_number" />
            </Datagrid>
          </ReferenceManyField>
        </FormTab>
        <FormTab label="Running Sessions">
          <ReferenceManyField
            addLabel={false}
            sort={{ field: "id", order: "DESC" }}
            reference="running_sessions"
            target="doctor"
            pagination={<Pagination />}
          >
            <Datagrid>
              <ShowButton />
              <TextField source="id" />
              <PatientReferenceField
                label="Patient"
                source="patientInfo.id"
                allowEmpty
                sortBy="patientInfo"
              />
              <TextField
                source="platformInfo.os"
                label="OS"
                sortBy="platformInfo__os"
              />
              <TextField source="mode" sortable={false} />
              <FunctionField
                label="Devices Number"
                render={(record) => R.length(record.devices)}
              />
              <ArrayField source="devices" label="Serials">
                <SingleFieldList>
                  <ChipField source="serialNumber" />
                </SingleFieldList>
              </ArrayField>
              <TextField
                source="programName"
                label="Program"
                sortable={false}
              />
              <TextField
                label="Muscle Group"
                source="muscleGroupName"
                sourtable={false}
              />
              <TextField source="type" sortable={false} />
              <NumberField source="painScoreBefore" label="Pain Score Before" />
              <DateField source="startDate" showTime />
              <DateField
                source="expectedFinishDate"
                showTime
                label="End Date (expected)"
              />
            </Datagrid>
          </ReferenceManyField>
        </FormTab>
        <FormTab label="Completed Sessions">
          <ReferenceManyField
            addLabel={false}
            sort={{ field: "id", order: "DESC" }}
            reference="completed_sessions"
            target="doctor"
            pagination={<Pagination />}
          >
            <Datagrid>
              <ShowButton />
              <TextField source="id" />
              <PatientReferenceField
                label="Patient"
                source="patientInfo.id"
                allowEmpty
                sortBy="patientInfo"
              />
              <TextField
                source="platformInfo.os"
                label="OS"
                sortBy="platformInfo__os"
              />
              <FunctionField
                label="Completeness"
                render={(record) =>
                  `${R.pathOr(
                    "None",
                    ["completionSummary", "completionPercent"],
                    record
                  )} %`
                }
              />
              <TextField source="mode" sortable={false} />
              <FunctionField
                label="Devices Number"
                render={(record) => R.length(record.devices)}
              />
              <ArrayField source="devices" label="Serials">
                <SingleFieldList>
                  <ChipField source="serialNumber" />
                </SingleFieldList>
              </ArrayField>
              <TextField
                source="programName"
                label="Program"
                sortable={false}
              />
              <TextField
                label="Muscle Group"
                source="muscleGroupName"
                sourtable={false}
              />
              <TextField source="type" sortable={false} />
              <TextField
                source="completionSummary.intensitySummary.max"
                label="Max Intensity"
                sortable={false}
              />
              <TextField
                source="completionSummary.intensitySummary.longest"
                label="Longest Intensity"
                sortable={false}
              />
              <NumberField
                source="painScoreBefore"
                label="Pain Score Before"
                sortable={false}
              />
              <NumberField
                source="completionSummary.painScoreAfter"
                label="Pain Score After"
                sortable={false}
              />
              <DateField source="startDate" showTime />
              <DateField
                source="completionSummary.finishDate"
                showTime
                label="End Date"
              />
            </Datagrid>
          </ReferenceManyField>
        </FormTab>
      </TabbedForm>
    </Edit>
  );
};
